'use client';

import ErrorPage from 'components/commercetools-ui/organisms/error-page';

export default function GlobalError({ reset }: { reset: () => void }) {
  return <ErrorPage reset={reset} />;
}
